module.exports = __webpack_public_path__ + "c6ef65552d9e893c54c3db3b49fc9423.pdf";